"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GithubProductDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var external_repo_1 = require("./external-repo");
var timestamp_1 = __importDefault(require("./timestamp"));
exports.GithubProductDecoder = ts_data_json_1.JsonDecoder.object({
    externalService: external_repo_1.githubDecoder,
    title: ts_data_json_1.JsonDecoder.string,
    archived: ts_data_json_1.JsonDecoder.boolean,
    deleted: ts_data_json_1.JsonDecoder.boolean,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    author: ts_data_json_1.JsonDecoder.string,
}, 'GithubProduct');
